import { Body, Margin } from '@spritz-finance/ui'
import { useState } from 'react'
import styled from 'styled-components'
import InfoIconImage from '../../../../../../assets/icons/info-icon.svg'
import { Column } from '../../../../../../components/Layout/Column'
import { Feature, useFeatureFlag } from '../../../../../../context/useFeatureFlag'
import { formatCurrency } from '../../../../../../utils/format'
import { DirectPayType, useDirectPayContext } from '../../context/DirectPayContext'
import { PricingDialog } from '../PricingDialog'

const LineItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 8px;
`
const Container = styled.div`
    padding: ${Margin.Small};
`
const BottomLine = styled.div`
    width: 100%;
    border-bottom: 1px solid rgba(214, 214, 214, 1);
    margin-bottom: 8px;
`

export const InfoIcon = styled.img.attrs({
    src: InfoIconImage,
})`
    cursor: pointer;
    width: 18px;
    height: 18px;
    margin-left: 2px;
    position: relative;
    top: 2px;
`

export const PriceBreakdown = ({
    rewardsAmount,
    testAmountActive,
    testAmount,
    amount,
    feeAmount,
    billPayTotal,
}: {
    rewardsAmount?: number
    testAmountActive?: boolean
    testAmount?: number
    amount?: number
    feeAmount?: number
    billPayTotal?: number
}) => {
    const { type } = useDirectPayContext()
    const offramp = type === DirectPayType.OffRamp
    const [pricingDialogOpen, setPricingDialogOpen] = useState(false)
    const pricingEnabled = useFeatureFlag(Feature.Pricing)
    const youPayAmount = Number(feeAmount ?? 0) + Number(amount ?? 0)

    let totalText = ''
    if (type === DirectPayType.OffRamp) {
        totalText = 'transfer'
    } else if (type === DirectPayType.BillPay) {
        totalText = 'bill payment'
    }

    return (
        <Container>
            <Column style={{ width: '100%' }}>
                <LineItem>
                    <Body.SmBold size={16} secondary>
                        {`Total ${totalText} amount`}
                    </Body.SmBold>
                    <div style={{ display: 'flex', flexGrow: '1' }} />
                    <Body.Med size={16} secondary>
                        {formatCurrency(billPayTotal)}
                    </Body.Med>
                </LineItem>

                {!!rewardsAmount && (
                    <LineItem>
                        <Body.SmBold size={16} secondary>
                            Rewards applied
                        </Body.SmBold>
                        <div style={{ display: 'flex', flexGrow: '1' }} />
                        <Body.Med size={16} secondary>
                            {formatCurrency(rewardsAmount)}
                        </Body.Med>
                    </LineItem>
                )}

                {!!testAmountActive && (
                    <LineItem>
                        <Body.SmBold size={16} secondary>
                            Test payment matched
                        </Body.SmBold>
                        <Body.Med size={16} secondary>
                            + {formatCurrency(testAmount)}
                        </Body.Med>
                    </LineItem>
                )}

                {!!pricingEnabled && (
                    <LineItem>
                        <Body.SmBold size={16} secondary>
                            Spritz fee <InfoIcon onClick={() => setPricingDialogOpen(true)} />
                        </Body.SmBold>
                        <Body.Med size={16} secondary>
                            {formatCurrency(feeAmount)}
                        </Body.Med>
                    </LineItem>
                )}

                <BottomLine />

                <LineItem>
                    <Body.SmBold size={16} secondary>
                        You pay
                    </Body.SmBold>
                    <Body.Bold size={16} secondary>
                        {formatCurrency(youPayAmount)}
                    </Body.Bold>
                </LineItem>
            </Column>
            <PricingDialog open={pricingDialogOpen} onClose={() => setPricingDialogOpen(false)} />
        </Container>
    )
}
